import { api } from "../../api/http";

// Noticias
const NEWS_BASE = "/api/backoffice/news/";

export async function listNews(params = {}) {
  const res = await api.get(NEWS_BASE, { params });
  return res.data;
}

export async function createNews(payload) {
  const res = await api.post(NEWS_BASE, payload);
  return res.data;
}

export async function updateNews(id, payload) {
  const res = await api.patch(`${NEWS_BASE}${id}/`, payload);
  return res.data;
}

export async function deleteNews(id) {
  const res = await api.delete(`${NEWS_BASE}${id}/`);
  return res.data;
}

// Carrusel
const CAROUSEL_BASE = "/api/backoffice/carousel/";

export async function listCarousel(params = {}) {
  const res = await api.get(CAROUSEL_BASE, { params });
  return res.data;
}

export async function createCarouselItem(payload) {
  const res = await api.post(CAROUSEL_BASE, payload);
  return res.data;
}

export async function updateCarouselItem(id, payload) {
  const res = await api.patch(`${CAROUSEL_BASE}${id}/`, payload);
  return res.data;
}

export async function deleteCarouselItem(id) {
  const res = await api.delete(`${CAROUSEL_BASE}${id}/`);
  return res.data;
}

// Configuración Web (se asume un solo registro)
const WEB_CONFIG_BASE = "/api/backoffice/web-config/";

export async function getWebConfig() {
  const res = await api.get(WEB_CONFIG_BASE);
  const data = res.data;
  if (Array.isArray(data)) {
    return data[0] || null;
  }
  return data;
}

export async function saveWebConfig(payload) {
  const current = await getWebConfig();
  if (current && current.id) {
    const res = await api.patch(`${WEB_CONFIG_BASE}${current.id}/`, payload);
    return res.data;
  }
  const res = await api.post(WEB_CONFIG_BASE, payload);
  return res.data;
}

